import { composeAPI } from "../Common/api";
import dscpComposition from "./composition";

export const composedAPI = composeAPI(dscpComposition);
